export default {
    "add_to_cart": {
        "label": "In den Warenkorb Button",
    },
    "cart": {
        "label": "Warenkorb Button",
    },
    "info_text": 'Unser Plugin platziert "Zum Warenkorb" -Buttons auf der Artikelseite und "Warenkorb"-Buttons im gesamten Shop, die beim Scrollen sichtbar bleiben. So hat der Kunde jederzeit die Möglichkeit, den Checkout anzustoßen.'
}
